export const DEFAULT_LOCALE = "en"
export const ALTERNATIVE_LOCALES = ["de"] as const
export type AlternativeLocale = (typeof ALTERNATIVE_LOCALES)[number]
export const LOCALES = [DEFAULT_LOCALE, ...ALTERNATIVE_LOCALES] as const
export type Locale = (typeof LOCALES)[number]

export function isValidLocale(locale: unknown): locale is Locale {
  return LOCALES.includes(locale as Locale)
}

export function isAlternativeLocale(
  locale: unknown,
): locale is AlternativeLocale {
  return ALTERNATIVE_LOCALES.includes(locale as AlternativeLocale)
}

export function getLocaleFromPathname(pathname: string): Locale {
  const locale = pathname.split("/")[1]
  if (isValidLocale(locale)) {
    return locale
  }

  return DEFAULT_LOCALE
}
